export const iconFontAwesomeHumanitarianPersonCircleMinus = (
	<i className="fa-solid fa-person-circle-minus"></i>
);
